module.exports = __webpack_public_path__ + "img/face-sad.4b19065a.svg";